import type { DateRange, EventsParams, PlateVisitsParams } from './params'

/** Ключи кэша TanStack Query — в одном месте, чтобы инвалидация не расползалась по коду. */
export const queryKeys = {
  me: ['auth', 'me'] as const,
  columns: ['columns'] as const,
  cashiers: ['cashiers'] as const,
  queues: ['queues'] as const,
  queuesHistory: (range: DateRange) => ['queues', 'history', range] as const,
  visitors: (range: DateRange) => ['visitors', range] as const,
  vehiclesSummary: (range: DateRange) => ['vehicles', 'summary', range] as const,
  topPlates: (range: DateRange) => ['vehicles', 'top', range] as const,
  plateVisitsChart: (range: DateRange) => ['vehicles', 'chart', range] as const,
  plateVisits: (params: PlateVisitsParams) => ['vehicles', 'visits', params] as const,
  events: (params: EventsParams) => ['events', 'list', params] as const,
  event: (id: string) => ['events', 'item', id] as const,
}
